import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../..';
import useSetNewPassword from '../../hooks/useSetNewPassword';
import commonStyles from '../Common.module.css';
import Spinner from '../spinners/Spinner';
import styles from './Login.module.css';

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const setNewPassword = useSetNewPassword();
    const email = searchParams.get("email")!;
    const resetToken = searchParams.get("resetToken")!;
    const authStore = useAuthStore();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isResetCompleted, setIsResetCompleted] = useState(false);

    const resetPassword = async () => {
        if (!email || !resetToken || !password || password !== confirmPassword)
            return;

        await setNewPassword(email, password, resetToken);
        setIsResetCompleted(true);
    };

    return (
        <div className={styles.background}>
            {!isResetCompleted ? (
                <div className={styles.container} onKeyUp={e => e.key === "Enter" && resetPassword()}>
                    <a href="/" className={styles.logoLink}></a>
                    <div className={styles.row}>
                        Enter your new Recity password.
                    </div>
                    <div className={styles.row}>
                        <label className={styles.label}>
                            EMAIL
                            <input
                                value={email}
                                readOnly
                            />
                        </label>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.label}>
                            PASSWORD
                            <input
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                type="password"
                                placeholder="Password"
                            />
                        </label>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.label}>
                            CONFIRM PASSWORD
                            <input
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                                type="password"
                                placeholder="Confirm Password"
                            />
                        </label>
                    </div>
                    <div className={[styles.rowHigh, styles.rowRight].join(" ")}>
                        {authStore.isLoading ? (
                            <Spinner className={styles.loginSpinner} />
                        ) : (
                            <button className={commonStyles.primaryButton} onClick={resetPassword}>
                                Reset Password
                            </button>
                        )}
                    </div>
                </div>
            ) : (
                <div className={styles.container}>
                    <a href="/" className={styles.logoLink}></a>
                    <div className={styles.row}>
                        Your Password has been reset.
                    </div>
                    <div className={styles.row}>
                        <Link to="/login" className={commonStyles.link}>Click here to login.</Link>
                    </div>
                </div>
            )}
        </div>
    );
}

export default observer(ResetPassword);